import cl from 'clsx';
import { ReactNode } from 'react';

import classes from './Table.module.scss';
import {
  FILLER_STYLE,
  TABLE_COLUMNS_LAYOUT,
  TableReactNodeRecord,
} from './tableColumnsLayout';

export type TableProps = {
  children: ReactNode;
  className?: string;
};
export const Table = ({ children, className }: TableProps) => {
  const tableHead: TableReactNodeRecord = {
    ordinal: '№',
    photo_url: '',
    full_name: 'Логин',
    comment: 'Комментарий',
    grantedAt: 'Добавлен',
    admin: 'Админ',
    pulse: (
      <span>
        Отправлять
        <br /> пульс
      </span>
    ),
    audience: 'Аудитория',
    invite_link: 'Доступ ко всей статистике',
  };

  return (
    <div className={cl(classes.tableWrapper, className)}>
      <div className={classes.tableScroll}>
        <table>
          <thead>
            <tr>
              {TABLE_COLUMNS_LAYOUT.map(({ key, style, className }) => (
                <th key={key} style={style} className={className}>
                  {tableHead[key]}
                </th>
              ))}
              <th style={FILLER_STYLE} />
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};
